// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import claims from './claims';
import claimsFiltered from './claims-filtered';
import {combineReducers} from 'redux';
import facets from './facets';
import isInitialLoad from './initial-load';
import searchFilters from './search-filters';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claims,
    claimsFiltered,
    facets,
    isInitialLoad,
    searchFilters
});



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/reducers/index.js